import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ComingSoon from "../pages/ComingSoon";
import MaquinaDeSolda from "../pages/maquina-de-solda-de-geomembrana/page";
import Automatica from "../pages/maquina-de-solda-geomembrana-automatica/page";
import Manual from "../pages/maquina-de-solda-geomembrana-manual/page";
import Pead from "../pages/maquina-de-solda-pead/page";
import Preco from "../pages/maquina-de-solda-de-geomembrana-preco/page";
import Comprar from "../pages/comprar-maquina-de-solda-de-geomembrana/page";
import Modelos from "../pages/modelos-de-maquinas/page";
import ModeloDetalhe from "../pages/modelo-de-maquina/page";
import Sobre from "../pages/sobre/page";
import Contato from "../pages/contato/page";
import SoldagemDeGeomembrana from "../pages/soldagem-de-geomembrana/page";
import ComoSoldarGeomembrana from "../pages/como-soldar-geomembrana/page";
import GeomembranaPead from "../pages/geomembrana-pead/page";
import CunhaQuenteGeomembrana from "../pages/cunha-quente-geomembrana/page";
import ExtrusoraGeomembrana from "../pages/extrusora-geomembrana/page";
import Aplicacoes from "../pages/aplicacoes/page";
import AplicacaoDetail from "../pages/aplicacoes/detail/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/maquina-de-solda-de-geomembrana", element: <MaquinaDeSolda /> },
  { path: "/maquina-de-solda-geomembrana-automatica", element: <Automatica /> },
  { path: "/maquina-de-solda-geomembrana-manual", element: <Manual /> },
  { path: "/maquina-de-solda-pead", element: <Pead /> },
  { path: "/maquina-de-solda-de-geomembrana-preco", element: <Preco /> },
  { path: "/comprar-maquina-de-solda-de-geomembrana", element: <Comprar /> },
  { path: "/soldagem-de-geomembrana", element: <SoldagemDeGeomembrana /> },
  { path: "/como-soldar-geomembrana", element: <ComoSoldarGeomembrana /> },
  { path: "/geomembrana-pead", element: <GeomembranaPead /> },
  { path: "/cunha-quente-geomembrana", element: <CunhaQuenteGeomembrana /> },
  { path: "/extrusora-geomembrana", element: <ExtrusoraGeomembrana /> },
  { path: "/modelos-de-maquinas", element: <Modelos /> },
  { path: "/modelos-de-maquinas/:slug", element: <ModeloDetalhe /> },
  { path: "/aplicacoes", element: <Aplicacoes /> },
  { path: "/aplicacoes/:slug", element: <AplicacaoDetail /> },
  { path: "/faq", element: <ComingSoon /> },
  { path: "/blog", element: <ComingSoon /> },
  { path: "/sobre", element: <Sobre /> },
  { path: "/assistencia-tecnica", element: <ComingSoon /> },
  { path: "/contato", element: <Contato /> },
  { path: "/politica-de-privacidade", element: <ComingSoon /> },
  { path: "/politica-de-cookies", element: <ComingSoon /> },
  { path: "/termos-de-uso", element: <ComingSoon /> },
  { path: "*", element: <NotFound /> },
];

export default routes;